import { render, staticRenderFns } from "./Award.vue?vue&type=template&id=e4c75d02&scoped=true"
import script from "./Award.vue?vue&type=script&setup=true&lang=js"
export * from "./Award.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Award.vue?vue&type=style&index=0&id=e4c75d02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c75d02",
  null
  
)

export default component.exports